import type { HTMLAttributes, ReactNode } from 'react'
import ReactDOM from 'react-dom'

import isMounted from '../../utils/hooks/useIsMounted'

export default function Portal(props: HTMLAttributes<HTMLDivElement>): ReactNode | null {
  if (!isMounted()) return null

  const themeBody = document.querySelector('.body')
  if (!themeBody) return null

  return ReactDOM.createPortal(<div {...props} />, themeBody)
}
